export default __webpack_public_path__ + "static/fan_w.172fd34340024707ce002b2b06da574f.png";